import { getRequest, postRequest, urlTitle ,monitorGateway} from "@/utils/request";
import qs from "qs";
window.qs = qs;
// 设备管理管理
export const deviceApi = {
  // 设备管理列表
  queryUnitName: () => {
    return getRequest(`${urlTitle}/companyInfo/construction`);
  },
  // 获取回路信息
  queryCircuitName: (params) => {
    return getRequest(`${urlTitle}/device/info/getLoopIdAndName`,params);
  },
  // 设备管理列表
  queryDevice: (params) => {
    return getRequest(`${monitorGateway}/device/info/index`, params);
  },
  // 创建设备管理
  createDevice: (params) => {
    return postRequest(`${monitorGateway}/device/info/save`, params);
  },
  // 修改设备管理
  updateDevice: (params) => {
    return postRequest(`${monitorGateway}/device/info/update`, params);
  },
  // 删除设备管理
  deleteDevice: (id) => {
    return postRequest(`${monitorGateway}/device/info/delete/${id}`);
  },
};
